// Opt-in: open header dropdowns (regular + brands panel) on hover, on
// pointer-capable desktop viewports. Loaded only when the header section's
// "Open menu dropdowns on hover" setting is enabled. Keyboard (Enter/Space) and
// touch behaviour are left intact for accessibility.
(function () {
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (min-width: 990px)').matches) {
    return;
  }

  const CLOSE_DELAY = 180; // ms grace period while moving between the item and its panel
  const registry = []; // every enhanced menu, so opening one can close the rest instantly

  const enhance = (menu) => {
    const details = menu.querySelector('details');
    if (!details || menu.dataset.hoverBound) return;
    menu.dataset.hoverBound = 'true';
    const summary = details.querySelector('summary');
    let closeTimer = null;

    const closeNow = () => {
      clearTimeout(closeTimer);
      details.removeAttribute('open');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    };

    const entry = { closeNow };
    registry.push(entry);

    const open = () => {
      clearTimeout(closeTimer);
      // Exclusive: close every other dropdown immediately so two never overlap.
      registry.forEach((other) => {
        if (other !== entry) other.closeNow();
      });
      if (!details.open) {
        details.setAttribute('open', '');
        if (summary) summary.setAttribute('aria-expanded', 'true');
      }
    };

    const scheduleClose = () => {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(closeNow, CLOSE_DELAY);
    };

    menu.addEventListener('mouseenter', open);
    menu.addEventListener('mouseleave', scheduleClose);

    // Hover controls the menu; suppress MOUSE clicks on the trigger so a click
    // can't fight the hover state. Keyboard activation (click detail 0) still works.
    if (summary) {
      summary.addEventListener('click', (e) => {
        if (e.detail > 0) e.preventDefault();
      });
    }
  };

  const enhanceAll = (root) => {
    const scope = root || document;
    const header =
      scope.querySelector('.header-wrapper') ||
      scope.querySelector('header') ||
      document.querySelector('.header-wrapper');
    // Marks the header so the no-animation / aligned-drop CSS applies only when
    // hover mode is genuinely active (desktop + pointer).
    if (header) header.classList.add('header-hover-menus');
    scope.querySelectorAll('header-menu').forEach(enhance);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhanceAll());
  } else {
    enhanceAll();
  }
  // Re-bind after a theme-editor section re-render.
  document.addEventListener('shopify:section:load', (e) => enhanceAll(e.target));
})();
